import { Box, Modal as MuiModal } from "@mui/material"

const Modal = (props) => {
    const { open, onClose, styles, component, onSubmit } = props
    return <MuiModal open={open} onClose={onClose} styles={styles}>
        <Box
            component={component}
            onSubmit={component === "form" ? onSubmit : null}
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: "background.paper",
                p: 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
            }}>
            {props.children}
        </Box>
    </MuiModal>
}

export default Modal
